import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const funders = [
  {
    path: '/vector/funders',
    name: 'vector-funders-home',
    component: () => import('@/pages/vector/funders/FundersListPage.vue'),
    meta: {
      title: 'Funders',
      resource: 'Vector',
      action: 'read',
      subject: 'Funder',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/funders/new',
    name: 'vector-funders-new',
    component: () => import('@/pages/vector/funders/NewFunderPage.vue'),
    meta: {
      title: 'New Funder',
      resource: 'Vector',
      action: 'create',
      subject: 'Funder',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/funders/:funder_uuid',
    name: 'vector-funders-funder-details',
    component: () => import('@/pages/vector/funders/FunderDetailPage.vue'),
    meta: {
      title: 'Funder Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'Funder',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/funders/programs',
    name: 'vector-funders-programs-home',
    component: () => import('@/pages/vector/programs/ProgramsListPage.vue'),
    meta: {
      title: 'Programs',
      resource: 'Vector',
      action: 'read',
      subject: 'Program',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/funders/program/:program_uuid',
    name: 'vector-funders-programs-program-details',
    component: () => import('@/pages/vector/programs/ProgramDetailPage.vue'),
    meta: {
      title: 'Program Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'Program',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/funders/program/:program_uuid/audit/:audit_uuid',
    name: 'vector-funders-programs-audit-details',
    component: () => import('@/pages/vector/programs/ProgramAuditDetailPage.vue'),
    meta: {
      title: 'Program Audit',
      resource: 'Vector',
      action: 'read',
      subject: 'Program',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/funders/programs/import-status/:program_creator_update_uuid',
    name: 'vector-programs-import-status',
    component: () => import('@/pages/vector/programs/import-status.vue'),
    meta: {
      title: 'Import Program Status',
      resource: 'Vector',
      action: 'read',
      subject: 'Program',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default funders
